<template>
  <div class="page">
    <div class="fixed-top">
      <div class="van-hairline--bottom">
          <van-cell-group>
            <van-cell title="开始时间" :value="startTime" is-link size="large" @click="showDatetimePickerPopup('start')" style="background: #fff;" />
            <van-cell title="结束时间" :value="endTime" is-link size="large" @click="showDatetimePickerPopup('end')" style="background: #fff;" />
          </van-cell-group>
      </div>
    </div>

    <div class="data-box van-hairline--top-bottom">
      <van-row>
        <van-col class="item van-hairline--right" span="8">
          <div class="value"><small>¥ </small>{{summaryData == null ? '-' : formatPrice(summaryData.orderAmount)}}</div>
          <div class="label">订单总额</div>
        </van-col>
        <van-col class="item van-hairline--right" span="8">
          <div class="value"><small>¥ </small>{{summaryData == null ? '-' : formatPrice(summaryData.continuedAmount)}}</div>
          <div class="label">续单总额</div>
        </van-col>
        <van-col v-if="summaryData != null && summaryData.discountAmount != null && summaryData.discountAmount > 0" class="item van-hairline--right" span="8">
          <div class="value"><small>¥ </small>{{summaryData == null ? '-' : formatPrice(summaryData.discountAmount)}}</div>
          <div class="label">优惠券金额<van-icon name="question-o" size="14" @click.stop="showTip"/></div>
        </van-col>
        <van-col v-if="summaryData != null && summaryData.refundAmount != null && summaryData.refundAmount > 0" class="item van-hairline--right" span="8">
          <div class="value"><small>¥ </small>{{summaryData == null ? '-' : formatPrice(summaryData.refundAmount)}}</div>
          <div class="label">退款金额<van-icon name="question-o" size="14" @click.stop="showTip('refundAmount')"/></div>
        </van-col>
        <van-col v-if="summaryData != null && summaryData.continuedDiscountAmount != null && summaryData.continuedDiscountAmount > 0" class="item van-hairline--right" span="8">
          <div class="value"><small>¥ </small>{{summaryData == null ? '-' : formatPrice(summaryData.continuedDiscountAmount)}}</div>
          <div class="label">续单优惠券金额<van-icon name="question-o" size="14" @click.stop="showTip"/></div>
        </van-col>
        <van-col class="item van-hairline--right" :span="8">
          <div class="value"><small>¥ </small>{{summaryData == null ? '-' : formatPrice(summaryData.wagesAmount)}}</div>
          <div class="label">总工资</div>
        </van-col>
      </van-row>
    </div>

    <van-list
            v-model="loading"
            :finished="listFinished"
            finished-text="没有更多了"
            :immediate-check="false"
            @load="loadData"
    >
      <div class="overflow-slide">
        <table class="table" bgcolor="#fff" style="margin-top: 8px;text-align: center;width: 100%;">
          <tr>
            <th>组名</th>
            <th>订单金额</th>
            <th>续单金额</th>
            <template v-if="[1,6].includes($store.state.shop.id)">
              <th>邀请</th>
              <th>首消</th>
              <th>外宣金额</th>
              <th>续费率</th>
              <th>续单率</th>
            </template>
            <template v-else>
              <th>续单率</th>
              <th>续费率</th>
            </template>
            <th>续客率</th>
            <th>客单价</th>
            <th v-if="summaryData != null && summaryData.discountAmount != null && summaryData.discountAmount > 0">
              优惠券金额<van-icon name="question-o" color="white" size="14" custom-style="iconStyle" @click.stop="showTip"/>
            </th>
            <th v-if="summaryData != null && summaryData.continuedDiscountAmount != null && summaryData.continuedDiscountAmount > 0">
              续单优惠券金额<van-icon name="question-o" color="white" size="14" custom-style="iconStyle" @click.stop="showTip"/>
            </th>
            <th>工资</th>
          </tr>
          <tr v-for="(item, index) in list" :key="index">
            <td>{{item.groupName}}</td>
            <td><small>¥ </small>{{formatPrice(item.orderAmount)}}</td>
            <td><small>¥ </small>{{formatPrice(item.continuedAmount)}}</td>
            <template v-if="[1,6].includes($store.state.shop.id)">
              <td>{{ item.distDistributorUserCount || 0 }}</td>
              <td>{{ item.distDistributorFirstConsumeCount || 0 }}</td>
              <td><small>¥ </small>{{formatPrice(item.distDistributorUserOrderAmount)}}</td>
              <td>{{calContinuedAmountPercent(item.continuedAmount, item.orderAmount)}}%</td>
              <td>{{calContinuedPercent(item.orderCount, item.continuedCount)}}%</td>
            </template>
            <template v-else>
              <td>{{calContinuedPercent(item.orderCount, item.continuedCount)}}%</td>
              <td>{{calContinuedAmountPercent(item.continuedAmount, item.orderAmount)}}%</td>
            </template>
            <td>{{calContinuedUserPercent(item.continuedUserCount, item.userCount)}}%</td>
            <td><small>¥ </small>{{calUserUnitPrice(item.orderAmount, item.userCount)}}</td>
            <td v-if="summaryData != null && summaryData.discountAmount != null && summaryData.discountAmount > 0">
              <small>¥ </small>{{formatPrice(item.discountAmount)}}
            </td>
            <td v-if="summaryData != null && summaryData.continuedDiscountAmount != null && summaryData.continuedDiscountAmount > 0">
              <small>¥ </small>{{formatPrice(item.continuedDiscountAmount)}}
            </td>
            <td><small>¥ </small>{{formatPrice(item.wagesAmount)}}</td>
          </tr>
        </table>
      </div>
    </van-list>

    <!-- 选择日期 -->
    <van-popup
            v-model="datetimePickerPopupShow"
             class="datetime-picker-popup"
             position="bottom"
    >
      <van-datetime-picker
              v-model="datetimePicker.value"
              type="date"
              :max-date="datetimePicker.maxDate"
              :formatter="datetimePickerFormatter"
              @confirm="datetimePickerConfirm"
              @cancel="datetimePickerPopupShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Popup, Button, List, CellGroup, Cell, Row, Col, DatetimePicker, ActionSheet, Dialog, Toast, Icon} from 'vant';
  import { getDefaultTime, getSumAmount, listContinuedAmount } from '@/api/admin/leader-wages'
  import moment from 'moment';
  import Decimal from 'decimal.js';

  Vue.use(Popup)
      .use(Button)
      .use(List)
      .use(CellGroup)
      .use(Cell)
      .use(Row)
      .use(Col)
      .use(Icon)
      .use(DatetimePicker)
      .use(ActionSheet)
      .use(Dialog)
      .use(Toast)

  export default {
    name: 'admin-leader-wages',
    components: {

    },
    data () {
      return {
        datetimePickerPopupShow: false,
        datetimePicker: {
          field: null,
          value: null,
          maxDate: moment().add('1', 'weeks').toDate()
        },
        startTime: null,
        endTime: null,
        summaryData: null,
        list: [],
        loading: true,
        listFinished: false,
        pageNo: 1,
        pageSize: 30
      }
    },
    computed: {
    },
    methods: {
      // 计算续单率
      calContinuedPercent(count, continuedCount) {
        if(count > 0){
          return Decimal.mul(Decimal.div(continuedCount, count), 100).toFixed(2);
        }
        return 0
      },
      // 计算续费率
      calContinuedAmountPercent(continuedAmount, orderAmount) {
        if(orderAmount > 0){
          return Decimal.mul(Decimal.div(continuedAmount, orderAmount), 100).toFixed(2);
        }
        return 0
      },
      // 计算续客率
      calContinuedUserPercent(continuedUserCount, userCount) {
        if(userCount > 0){
          return Decimal.mul(Decimal.div(continuedUserCount, userCount), 100).toFixed(2);
        }
        return 0
      },
      // 计算客单价
      calUserUnitPrice(orderAmount, userCount) {
        if(userCount > 0){
          return Decimal.div(Decimal.div(orderAmount, userCount), 100).toFixed(2);
        }
        return 0
      },
      showTip(type){
        if(type === 'refundAmount'){
          Dialog.alert({
            message: '发生部分退款的金额'
          })
        } else {
          Dialog.alert({
            message: '优惠券金额是指开通了优惠券功能，设置的是和' + this.$store.state.label.clerkLabel + '共同承担优惠金额，就会有优惠券的金额，需要（订单金额-优惠券金额）X 组长提成比例 或（续单金额-续单优惠券金额）X 组长提成比例，得到组长的工资'
          })
        }
      },
      datetimePickerFormatter(field, value) {
        if (field === 'year') {
          return `${value}年`;
        } else if (field === 'month') {
          return `${value}月`
        } else if (field == 'day') {
          return `${value}日`
        }
        return value;
      },
      showDatetimePickerPopup(field) {
        this.datetimePicker.field = field
        if (field == 'start') {
          this.datetimePicker.value = moment(this.startTime).toDate()
        } else if (field == 'end') {
          this.datetimePicker.value = moment(this.endTime).toDate()
        }
        this.datetimePickerPopupShow = true;
      },
      datetimePickerConfirm(value) {
        this.datetimePickerPopupShow = false;
        if (this.datetimePicker.field == 'start') {
          this.startTime = moment(value).format('YYYY-MM-DD');
        } else if (this.datetimePicker.field == 'end') {
          this.endTime = moment(value).format('YYYY-MM-DD');
        }
        this.getSumAmount();
        this.loadData(true);
      },
      formatPrice(price) {
        if (price != null) {
          return Decimal.div(price, 100).toString()
        }
        return 0
      },
      getDefaultTime() {
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        getDefaultTime().then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.startTime = moment(data.startTime).format('YYYY-MM-DD')
            this.endTime = moment(data.endTime).format('YYYY-MM-DD')

            this.getSumAmount()
            this.loadData(true)
          } else {
            Dialog.alert({
              title: '加载默认时间失败',
              message: data.msg
            })
          }
        })
      },
      loadData(resetFirstPage) {
        // 重置为首页
        if (resetFirstPage) {
          this.pageNo = 1
        }
        // 清空数据
        if (this.pageNo == 1) {
          this.list = [];
        }
        this.loading = true
        listContinuedAmount(this.startTime, this.endTime, this.pageNo, this.pageSize).then(res => {
          this.loading = false
          const data = res.data;
          if (data.code == 0) {
            this.list = this.list.concat(data.list)
            if (data.hasNextPage) {
              this.listFinished = false
            } else {
              this.listFinished = true
            }
          } else {
            this.listFinished = true
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
          this.pageNo ++
        })
      },
      getSumAmount() {
        this.summaryData = null;
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        getSumAmount(this.startTime, this.endTime).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.summaryData = data.summaryData;
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      }
    },
    mounted() {
      this.getDefaultTime()
    },
    updated() {
      // 统一替换标签
      this.$replaceLabel(document.body, this.$store.state.label, true)
    }
  }
</script>

<style lang="less" scoped>

  .page {
  }

  .fixed-top {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: #fff;
  }

  .data-box {
    background: #fff;
    .item {
      padding: 15px 5px;
      text-align: center;
      .value {
        color: #ff6600;
        font-size: 18px;
      }
      .label {
        color: #666;
        font-size: 14px;
        margin-top: 6px;
      }
    }
  }

  .table {
    border-collapse:collapse;
    th, td {
      font-weight: normal;
      padding: 8px 0;
      border: 1px solid #eee;
      border-collapse:collapse;
    }
    th {
      color: #fff;
      background: var(--primary-color);
    }
    td {
      color: #666;
    }
  }
  .iconStyle {
    width: 20px;
  }
  .overflow-slide{
    overflow-x: auto;
    white-space: nowrap;
    justify-content: space-evenly;
  }
</style>
